import type { EventId } from "@/lib/odds-screen/live/types";

export type Stars = ReadonlySet<EventId>;

export const NO_STARS: Stars = new Set();

export const MAX_STARS = 500;

export function toggleStar(stars: Stars, id: EventId): Stars {
  const next = new Set(stars);
  if (!next.delete(id)) next.add(id);
  return new Set([...next].slice(-MAX_STARS));
}
